/// <reference path='../../interfaces/interfaces.d.ts' />


'use strict';

class HomeController {
    public static $inject = [
        'User',
        'Announcement',
        'Employee',
        '$uibModal',
        'Orgs',
        'toaster',
        '$state',
        '$stateParams',
        'Api',
        '$http',
        'bsLoadingOverlayService',
        '$scope'
    ];

    public user;
    public meetings;
    public announcesCount;
    public birthdays;
    public greeting;
    public displayname;
    public employee;
    public firstTimeUser = false;

    public agreeTOS = false;
    public agreePP = false;
    public acceptedBoth = false;
    public industries = ["accounting", "advertising", "aerospace and defense", "agriculture", "arts", "automotive", "banking", "biotechnology", "business services", "chemical", "construction", "consumer goods", "consumer services", "customer service", "e-commerce", "education", "electronics", "energy", "entertainment", "environmental products", "financial services", "food", "forestry", "healthcare", "hospitality", "human resources", "industrial goods and services", "information services", "information technology", "international business and trade", "investing", "logistics", "management", "marketing", "materials", "mining and drilling", "pharmaceuticals", "printing", "publishing", "real estate", "retail trade", "small business", "telecommunications", "textiles", "training", "transportation", "wholesale trade", "other"];
    public office_countries = ["Afghanistan","Albania","Algeria","American","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bonaire","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos [Keeling] Islands","Colombia","Comoros","Cook Islands","Costa Rica","Croatia","Cuba","Curacao","Cyprus","Czech Republic","Democratic Republic of the Congo","Denmark","Djibouti","Dominica","Dominican Republic","East Timor","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Ivory Coast","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar [Burma]","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","North Korea","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn Islands","Poland","Portugal","Puerto Rico","Qatar","Republic of the Congo","Romania","Russia","Rwanda","Réunion","Saint Barthélemy","Saint Helena","Saint Kitts and Nevis","Saint Lucia","Saint Martin","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Swaziland","Sweden","Switzerland","Syria","São Tomé and Príncipe","Taiwan","Tajikistan","Tanzania","Thailand","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","U.S. Minor Outlying Islands","U.S. Virgin Islands","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe","Aland"];
    public num_employees = ["1-10", "11-20", "21-50", "51-100", "101-500", "500+"];

    // callouts
    public isCurrent = -1;
    public hasPermission;
    public showOverlayCallOuts = false;
    public isHelping = false;
    public isTour = false;
    public not_insurance_only_client = true;
    public isHRM = true;

    public orgId;
    public org;
    public fromSource = '';

    // Profile strength related items
    public profileCurrentStep = 1;
    public profileTotalSteps = 6;
    public profileLevel = 'Beginner';
    public profileNextSection = 'Add Industry';
    public profileMessage = 'Checking your status...';

    public profileStepMessageMap = {
        1: "Let's get you started:",
        2: "Level:",
        3: "Leveled up:",
        4: "Getting there:",
        5: "You're almost there:",
        6: "All done: ",
    };

    public profileStepLevelMap = {
        1: "Beginner",
        2: "Beginner",
        3: "Intermediate",
        4: "Intermediate",
        5: "Expert",
        6: "HR Pro!",
    };

    public profileStepSectionTitleMap = {
        1: "Add Industry",
        2: "Add Office",
        3: "Configure Leave",
        4: "Set Insurance",
        5: "Employee Census",
    };

    constructor(private User: IUserService,
                private Announcement: IAnnouncementService,
                private Employee: IEmpService,
                private $uibModal: any,
                private Org: IOrgsService,
                public toaster: toaster.IToasterService,
                private $state: ng.ui.IStateService,
                private $stateParams: any,
                private Api: any,
                private $http: angular.IHttpService,
                private bsLoadingOverlayService: IBsLoadingService,
                private $scope: ng.IScope) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.orgId = this.$stateParams.id || undefined;
        if (this.$stateParams.fromSource) {
            this.fromSource = this.$stateParams.fromSource;
        }

        this.loadEmployeeAndOrg();
        this.$uibModal = $uibModal;
        this.user = User.getCurrentUser();
        this.not_insurance_only_client = !this.user.isInsuranceOnlyClient;
        this.isHRM = this.user.isHRM;

        this.Employee.setCoTourStatus(false);
        this.isTour = this.Employee.getCoTourStatus();

        if (!this.user.isSuperUser) {
            this.Announcement.loadAnounces().then((response) => {
                if (response.length > 99) {
                    this.announcesCount = '99+';
                } else {
                    this.announcesCount = response.length;
                }

            });
        }

        this.displayname = this.user.userData.extra.personal.first_name;
        this.get_Greeting();

        this.user = User.getCurrentUser();
        this.hasPermission = User.hasPermission;
    }


    public loadEmployeeAndOrg(): any {
        this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.employee = response;
            this.Org.getOrg(this.orgId).then((orgResponse: Restangular.IResponse) => {
                this.org = orgResponse;
                this.checkProfileStrength();
                if (!this.org.extra.marketing) {
                    this.org.extra.marketing = {};
                }

                if (!this.org.extra.marketing.hear_about_us) {
                    this.org.extra.marketing.hear_about_us = '';
                }
                this.checkLegal();
            });

        });
    }

    public startTour(params: any): any {
        this.$state.go('root.announcements');
    }

    public checkTourStart(): void {
        if (!this.user.userData.extra.help_boxes_visited) {
            this.user.userData.extra.help_boxes_visited = [];
        }
        let list: any = this.user.userData.extra.help_boxes_visited;
        this.isTour = false;
        if (list.length === 0) {
            // this.Employee.setCoTourStatus(true);
            this.isTour = true;
            this.startCallouts();
        }
    }

    public get_Greeting(): any {
        var numbers: number = Math.random();
        var timeNow: any = new Date();
        var hoursNow: any = timeNow.getHours();
        if (timeNow.getDay() === 1) {
            this.greeting = 'Happy Monday ';
        } else if (timeNow.getDay() === 2 || timeNow.getDay() === 4 || timeNow.getDay() === 6) {
            if (numbers < 0.3) {
                this.greeting = 'Hey ';
            } else if (numbers >= 0.3 && numbers < 0.6) {
                this.greeting = 'Hi ';
            } else if (numbers >= 0.6) {
                this.greeting = 'Hello ';
            }
        } else if (timeNow.getDay() === 3 || timeNow.getDay() === 5 || timeNow.getDay() === 7) {
            if (hoursNow < 12) {
                this.greeting = 'Morning ';
            } else if (hoursNow >= 12 && hoursNow <= 16) {
                this.greeting = 'Afternoon ';
            } else if (hoursNow >= 17) {
                this.greeting = 'Evening ';
            }
        }
    }

    public FirstTimeModal(): void {
        let that: any = this;
        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/first_time_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.continue = () => {
                    this.Employee.dismissTour(this.employee).then((response: Restangular.IResponse) => {
                        this.employee = response.data;
                    });
                    this.startCallouts();
                    $uibModalInstance.close();
                };
                $scope.dismissTour = () => {
                    this.Employee.dismissTour(this.employee).then((response: Restangular.IResponse) => {
                        this.employee = response.data;
                    });
                    $uibModalInstance.close();
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }
            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.Employee.setCoTourStatus(true);
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }

    public legalModal(): void {
        let that: any = this;
        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/legal_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.acceptTerms = () => {
                    if (that.agreePP && that.agreeTOS) {
                        this.bsLoadingOverlayService.start({referenceId: 'loader'});
                        that.acceptedBoth = true;
                        this.Employee.acceptPrivacyPolicy(this.employee).then(() => {
                            this.Employee.acceptToS(this.employee).then((response: Restangular.IResponse) => {
                                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                                this.employee = response.data;
                                this.toaster.pop('success', 'Success', 'Accepted Terms & Conditions and Privacy Policy');
                                this.checkLegal();
                                $uibModalInstance.close(that.acceptedBoth);
                            });
                        });
                    } else {
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        this.toaster.pop('warning', 'You must accept the Privacy Policy and Terms & Conditions to continue.');
                    }
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public infoModal(): void {
        let that: any = this;
        that.emitEvent('finsbury.myfinances.view');
        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/financeInfo.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                $scope.C = that;
                $scope.modalHeader = 'My Finances';
                $scope.modalDetail = 'Beneple and Finsbury Associates are currently collaborating on bringing you an innovative new platform to help manage your finances - ranging from personal insurance & protection to securing your future wealth.';
                $scope.confirmButton = 'Close';
                $scope.$uibModal = that.$uibModal;
                $scope.openFX = that.openFX;
                $scope.requestHealthCheck = that.requestHealthCheck;
                $scope.emitEvent = that.emitEvent;
                $scope.ok = () => {
                    $uibModalInstance.close();
                };
            }]
        });
        modal_instance.result.then(() => {
        });
    }

    public marketplaceModal(): void {
        let that: any = this;
        that.emitEvent('finsbury.myfinances.view');
        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/marketplaceInfo.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                $scope.C = that;
                $scope.modalHeader = 'My Finances';
                $scope.modalDetail = 'Beneple and Finsbury Associates are currently collaborating on bringing you an innovative new platform to help manage your finances - ranging from personal insurance & protection to securing your future wealth.';
                $scope.confirmButton = 'Close';
                $scope.$uibModal = that.$uibModal;
                $scope.openFX = that.openFX;
                $scope.requestHealthCheck = that.requestHealthCheck;
                $scope.emitEvent = that.emitEvent;
                $scope.ok = () => {
                    $uibModalInstance.close();
                };
            }]
        });
        modal_instance.result.then(() => {
        });
    }

    public openFX(): void {
        this.emitEvent('finsbury.myfinances.openfx.view');
    }

    // modal function to confirm an if you want to send an email to
    public requestHealthCheck(): void {
        this.emitEvent('safehands.healthcheck.request.open');
        let that = this;

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster:any): any {
                $scope.confirmation = false;
                $scope.modalHeader = 'Financial Health Check';
                $scope.modalDetail = 'One of our experts will be in touch soon to book a time that is suitable for you.';
                $scope.confirmButton = 'Request information';
                $scope.cancelButton = 'Cancel';
                $scope.toaster = toaster;
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                    that.emitEvent('safehands.healthcheck.request.confirm');
                    $scope.toaster.pop('success', 'Submitted', 'Your details have been submitted');
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                    that.emitEvent('safehands.healthcheck.request.cancel');
                    $scope.toaster.pop('warning', 'Cancelled', 'Details have not been sent');
                };
            }]
        });
        modalInstance.result.then((result) => {
            if (result) {
            } else {
            }
        });
    }


    public checkLegal(): any {
        // don't do legal check and tour when logging in via SSA
        if (this.user.isSuperUserMask) {
            // return;  fixme: remove after testing
        }

        // check if a user has a clearance level
        if (this.user.userData.user.clearance === '') {
            return;
        }

        // All higher level employees need to agree to T&C
        if (!this.employee.extra.terms_of_service || !this.employee.extra.terms_of_service.pp_agreed || !this.employee.extra.terms_of_service.tac_agreed) {
            this.legalModal();
            return
        }

        // The next items are checked only if we've just logged in
        if (this.fromSource !== 'login') {
            return;
        }

        // HRMs need to fill in company profile data
        if (this.user.userData.user.clearance === 'admin' && this.profileCurrentStep <= this.profileTotalSteps) {
            this.showProfileModal();
            return;
        }

        // Check the first login next steps
        this.checkSteps();
    }

    public v3_annoucement(): any {
        let that: any = this;
        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/welcome_v3.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.ok = () => {
                    this.Employee.dismissAnnouncementV3(this.employee).then((response: Restangular.IResponse) => {
                        this.employee = response.data;
                    });
                    this.checkSteps();
                    $uibModalInstance.close();
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public HearAboutUs(): void {
        let that: any = this;
        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/hear_about_us.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.aboutUsOptions = ['Google', 'Facebook or Twitter', 'Magazine or Newspaper', 'A Friend or Collegue', 'Networking Event', 'Online Advertisement', 'Marketing Email', 'Other'];
                $scope.hearAboutUs = '';
                $scope.ok = () => {
                    this.bsLoadingOverlayService.start({referenceId: 'loader'});
                    this.org.extra.marketing.hear_about_us = $scope.hearAboutUs;

                    let url: string = '/api/' + (this.$stateParams['id']
                            ? ('orgs/' + this.$stateParams.id)
                            : 'org'
                    );
                    this.$http.put(url, this.Api.stripRestangular(this.org))
                        .then((org: any) => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.org = org.data;
                            this.toaster.pop('success', 'Saved');
                            this.checkSteps();
                            $uibModalInstance.close();
                        }, () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Server error', 'Please, try again later');
                            this.checkLegal();

                            //this.checkSteps();
                            // close the modal if it fails because this will repear and ask everytime the homepage is loaded
                            $uibModalInstance.close();
                        });
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public AskIndustry(): void {
        let that: any = this;

        if (!this.org.extra.details) {
            this.org.extra.details = {}
        }
        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/profile/profile_industry.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.model = {
                    industry: this.org.extra.details.industry,
                    num_emp: this.org.extra.details.number_of_employees
                }
                $scope.ok = () => {
                    this.bsLoadingOverlayService.start({referenceId: 'loader'});

                    if (!this.org.extra.details) {
                        this.org.extra.details = {}
                    }

                    this.org.extra.details.industry = $scope.model.industry;
                    this.org.extra.details.number_of_employees = $scope.model.num_emp;

                    let url: string = '/api/' + (this.$stateParams['id']
                            ? ('orgs/' + this.$stateParams.id)
                            : 'org'
                    );
                    this.$http.put(url, this.Api.stripRestangular(this.org))
                        .then((org: any) => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.org = org.data;
                            this.toaster.pop('success', 'Saved');
                            $uibModalInstance.close();
                            this.checkProfileStrength();
                            this.checkLegal();
                        }, () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Server error', 'Please, try again later');
                            $uibModalInstance.close();
                        });
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
    }

    public AskOffice(): void {
        let that: any = this;

        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/profile/profile_office.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.model = {
                    name: null,
                    description: null,
                    country: 'United Arab Emirates',
                    address: null
                }

                $scope.ok = () => {
                    this.bsLoadingOverlayService.start({referenceId: 'loader'});

                    if (!this.org.extra.offices) {
                        this.org.extra.offices = [];
                    }
                    let new_office = {
                        name: $scope.model.name,
                        description: $scope.model.description,
                        country: $scope.model.country,
                        address: $scope.model.address,
                    };
                    this.org.extra.offices.push(new_office);

                    let url: string = '/api/' + (this.$stateParams['id']
                            ? ('orgs/' + this.$stateParams.id)
                            : 'org'
                    );
                    this.$http.put(url, this.Api.stripRestangular(this.org))
                        .then((org: any) => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.org = org.data;
                            this.toaster.pop('success', 'Saved');
                            $uibModalInstance.close();
                            this.checkProfileStrength();
                            this.checkLegal();
                        }, () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Server error', 'Please, try again later');
                            //this.checkSteps();
                            // close the modal if it fails because this will repear and ask everytime the homepage is loaded
                            $uibModalInstance.close();
                        });
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public AskLeave(): void {
        let that: any = this;
        if (!this.org.extra.leave) {
            this.org.extra.leave = {};
        }

        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/profile/profile_leave.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.model = {
                    leave_start: this.org.extra.leave.annual_cycle_start_date || moment().dayOfYear(1).format('YYYY-MM-DD'),
                    paid_leave_days: this.org.extra.leave.paid_leave_days_per_year || 25,   // TODO: Replace default value with config
                    sick_leave_days: this.org.extra.leave.sick_leave_days_per_year || 15,   // TODO: Replace default value with config
                };
                $scope.otherLocale = {
                    formatDate: function(date) {
                        let m = moment(date);
                        return m.isValid() ? m.format('D MMMM') : date;
                    },
                    parseDate: function(input) {
                        let m = moment(input, 'D MMMM', true);
                        return m.isValid() ? m.toDate() : new Date(NaN);
                    },
                    isDateComplete: function (dateString) {
                        dateString = dateString.trim();

                        // Look for two chunks of content (either numbers or text) separated by delimiters.
                        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-]))([a-zA-Z]{3,}|[0-9]{1,4})/;
                        return re.test(dateString);
                    }
                };

                $scope.ok = () => {
                    this.bsLoadingOverlayService.start({referenceId: 'loader'});

                    if (!this.org.extra.leave) {
                        this.org.extra.leave = {};
                    }

                    this.org.extra.leave.annual_cycle_start_date = moment($scope.model.leave_start).format('YYYY-MM-DD');
                    this.org.extra.leave.paid_leave_days_per_year = $scope.model.paid_leave_days;
                    this.org.extra.leave.sick_leave_days_per_year = $scope.model.sick_leave_days;

                    let url: string = '/api/' + (this.$stateParams['id']
                            ? ('orgs/' + this.$stateParams.id)
                            : 'org'
                    );
                    this.$http.put(url, this.Api.stripRestangular(this.org))
                        .then((org: any) => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.org = org.data;
                            this.toaster.pop('success', 'Saved');
                            $uibModalInstance.close();
                            this.checkProfileStrength();
                            this.checkLegal();
                        }, () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Server error', 'Please, try again later');
                            //this.checkSteps();
                            // close the modal if it fails because this will repear and ask everytime the homepage is loaded
                            $uibModalInstance.close();
                        });
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public MedicalRenewal(): void {
        let that: any = this;

        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/profile/profile_medical_renewal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
                $scope.model = {
                    renewal_date: null,
                    description: '',
                    premium: 0
                };
                $scope.ok = () => {
                    this.bsLoadingOverlayService.start({referenceId: 'loader'});
                    if (!this.org.extra.medical_insurance) {
                        this.org.extra.medical_insurance = {
                            insurance_contracts: [],
                            files: {},
                            preferred_providers: []
                        };
                    }

                    // Find medical insurance entry
                    let medicalInsuranceFound = false;
                    for (const insContract of this.org.extra.medical_insurance.insurance_contracts) {
                        if (insContract.insurance === 'Medical') {
                            insContract.renewal_date = moment($scope.model.renewal_date).format('YYYY-MM-DD');
                            insContract.description = $scope.model.description;
                            insContract.premium = $scope.model.premium.toString();
                            medicalInsuranceFound = true;
                        }
                    }

                    if (!medicalInsuranceFound) {
                        this.org.extra.medical_insurance.insurance_contracts.push({
                            insurance: 'Medical',
                            renewal_date: moment($scope.model.renewal_date).format('YYYY-MM-DD'),
                            description: $scope.model.description,
                            premium: $scope.model.premium.toString()
                        });
                    }

                    let url: string = '/api/' + (this.$stateParams['id']
                            ? ('orgs/' + this.$stateParams.id)
                            : 'org'
                    );
                    this.$http.put(url, this.Api.stripRestangular(this.org))
                        .then((org: any) => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.org = org.data;
                            this.toaster.pop('success', 'Saved');
                            this.checkProfileStrength();
                            this.checkLegal();
                            $uibModalInstance.close();
                        }, () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Server error', 'Please, try again later');
                            //this.checkSteps();
                            // close the modal if it fails because this will repear and ask everytime the homepage is loaded
                            $uibModalInstance.close();
                        });
                };
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public CensusUpload(): void {
        let that: any = this;

        var modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/profile/profile_census.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;

                $scope.loadCensus = () => {
                    $uibModalInstance.close();
                    this.$state.go('root.employees.import');
                }
            }],
            backdrop: 'static',
            keyboard: false
        });
        modal_instance.result.then(() => {
        });
    }

    public checkSteps(): any {
        if (!this.employee.extra.dismiss_tour) {
            this.employee.extra['dismiss_tour'] = false;
        }

        if (this.user.userData.user.clearance === 'admin') {
            if (this.employee.extra.dismiss_tour === false) {
                this.FirstTimeModal();
            }
        } else {
            this.checkTourStart();
        }
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        if (this.$scope) {
            this.$scope.$emit('$EL', eventName, eventAddData);
        } else {
            console.log('ERROR');
        }
    }

    public employeesLoaded(): boolean {
        // Check if employees are loaded
        return this.org
            && this.org.number_of_active_employees
            && this.org.number_of_active_employees > 1;
    }

    public checkProfileStrength(): void {
        // Check industry and num_employees
        if (!this.org.extra.details || !this.org.extra.details.industry || !this.org.extra.details.number_of_employees) {
            this.profileCurrentStep = 1;
        // Check if an office is defined
        } else if (!this.org.extra.offices || this.org.extra.offices.length == 0) {
            this.profileCurrentStep = 2;
        // Check if leave is configured
        } else if (!this.org.extra.leave || !this.org.extra.leave.annual_cycle_start_date
        || this.org.extra.leave.paid_leave_days_per_year == null
        || this.org.extra.leave.sick_leave_days_per_year == null
        ) {
            this.profileCurrentStep = 3;
        // Check if medical insurance is set
        } else if (!this.org.extra.medical_insurance || !this.org.extra.medical_insurance.insurance_contracts
            || !this.org.extra.medical_insurance.insurance_contracts.length
        ) {
            this.profileCurrentStep = 4;
        // Check if there are employees loaded
        } else if (!this.employeesLoaded()) {
            this.profileCurrentStep = 5;
        } else {
            this.profileCurrentStep = 6;
        }

        // Update profile strength values
        this.profileLevel = this.profileStepLevelMap[this.profileCurrentStep];
        this.profileNextSection = this.profileStepSectionTitleMap[this.profileCurrentStep];
        this.profileMessage = this.profileStepMessageMap[this.profileCurrentStep];
    }

    public showProfileModal(): void {
        switch (this.profileCurrentStep) {
            case 1:
                this.AskIndustry();
                break;
            case 2:
                this.AskOffice();
                break;
            case 3:
                this.AskLeave();
                break;
            case 4:
                this.MedicalRenewal();
                break;
            case 5:
                this.CensusUpload();
                break;
        }
    }
}

angular.module('beneple.global')
    .controller('HomeController', HomeController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/home.controller.ts